import logout from '@/mixins/logout.js'
import { USER_TOKEN, USER_TOKEN_EXPIRY_TIME } from '@/utils/constants'
export default {
  mixins: [logout],
  computed: {
    getTokenExpiryTime () {
      return localStorage.getItem(USER_TOKEN_EXPIRY_TIME)
    },
    isTokenExpired () {
      const tokenExpiryTime = localStorage.getItem(USER_TOKEN_EXPIRY_TIME)
      // if this is undefined, means that a user is not logged in
      // default token expiry will be false
      if (!tokenExpiryTime) {
        return false
      }
      const now = new Date().getTime()
      return now > Number(tokenExpiryTime)
    }
  },
  methods: {
    setToken (token, tokenExpiryTime) {
      const [datePart, timePart, offsetPart] = tokenExpiryTime.split(' ')
      localStorage.setItem(USER_TOKEN, token)
      const tokenExpiryTimeInMilliseconds = new Date(
        `${datePart}T${timePart}${offsetPart}`
      ).getTime()
      localStorage.setItem(
        USER_TOKEN_EXPIRY_TIME,
        tokenExpiryTimeInMilliseconds
      )
    },
    getToken () {
      const token = localStorage.getItem(USER_TOKEN)
      if (this.isTokenExpired) {
        logout()
        return null
      }
      return token
    }
  }
}
